import { getAssetFromCache, getCaptionFromCache } from 'root/lib/AssetLoader.new';

/**
 * Formats an audio asset object with src and caption properties
 * @param {object} assetObj - The asset object from curriculum
 * @returns {object} - Object with src and caption properties
 */
const getAudio = (assetObj) => ({
  src: getAssetFromCache(assetObj),
  caption: getCaptionFromCache(assetObj),
});

export default getAudio;
